import { render, staticRenderFns } from "./edit-goods-operation.vue?vue&type=template&id=4c674464&"
import script from "./edit-goods-operation.vue?vue&type=script&lang=js&"
export * from "./edit-goods-operation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports